import { useQuery } from '@tanstack/react-query';

import { withQuery } from '@/lib/qs';

import { useApiClient } from '../ApiClientProvider';
import { queryKeys, type ProductFilters } from '../keys';
import type { ProductFacets, ShopifyProductsResponse } from '../types/products';

export function useShopifyProducts(filters: ProductFilters, enabled = true) {
  const api = useApiClient();
  return useQuery<ShopifyProductsResponse, Error>({
    queryKey: queryKeys.products.list(filters),
    queryFn: ({ signal }) => api.get(withQuery('/admin/products', filters), signal),
    enabled,
  });
}

/**
 * Collections and product tags for the catalog filters, in one Shopify round trip
 * when the page opens. Kept fresh for the session: a merchant editing collections
 * in another tab is rare, and refetching per keystroke would burn their GraphQL
 * budget for a list that filters fine in the browser.
 */
export function useProductFacets(enabled = true) {
  const api = useApiClient();
  return useQuery<{ data: ProductFacets }, Error>({
    queryKey: queryKeys.products.facets,
    queryFn: ({ signal }) => api.get('/admin/products/facets', signal),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
